<template>
  <div>
    <div class="text-center font-medium my-6 lg:hidden mdsm:visible">
      {{ monthDisplay }}
    </div>
    <div class="dp-calender-header fs-12 text-black-light-5 mb-4">
      <div>Mon</div>
      <div>Tue</div>
      <div>Wed</div>
      <div>Thu</div>
      <div>Fri</div>
      <div>Sat</div>
      <div>Sun</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["month"],
  computed: {
    monthDisplay() {
      return this.month.format("MMMM YYYY");
    },
  },
};
</script>
